import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { helper } from 'src/environments/helper';
import { BeneficiariService } from './beneficiari.service';
import { PermissionsService } from 'src/app/services/permissions.service';
import { DataTablesResponse } from 'src/app/interfaces/data-table-response.interface';
import { MatDialog } from '@angular/material/dialog';
import Swal from 'sweetalert2';
import { DialogService } from 'src/app/services/dialog.service';
import { AddBeneficiarComponent } from './add-beneficiar/add-beneficiar.component';
import { BeneficiarListDT } from './beneficiari.interface';
import { BeneficiariDetaliiComponent } from './beneficiari-detalii/beneficiari-detalii.component';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';


@Component({
    selector: 'app-beneficiari',
    templateUrl: './beneficiari.component.html',
    styleUrls: ['./beneficiari.component.scss']
})
export class BeneficiariComponent {
    @ViewChild(DataTableDirective, { static: false })
    dtElement!: DataTableDirective;
    helper = helper;

    isLoading = false;
    showCard = false;

    dtOptions: any = {};
    dtTrigger: Subject<any> = new Subject<any>();
    dtInstance!: DataTables.Api;

    parameters: { key: string; value: number }[] = [
        { key: '--Alegeți--', value: -1 },
        { key: 'Da', value: 1 },
        { key: 'Nu', value: 0 },
    ];

    resetForm() {
        this.searchParamsForm.reset(this.initialFormValues);
        this.rerenderDT();
        this.showCard = true;
    }

    applyFilters(): void {
        this.rerenderDT(true);
    }

    toggleCard() {
        this.showCard = !this.showCard;
    }

    searchParamsForm!: FormGroup;

    //Form Initial Values

    initialFormValues = {
        filter_name: '',
        filter_cnp: '',
        filter_absente: -1,
    };

    buildSearchParamsForm() {
        this.searchParamsForm = new FormGroup({
            filter_name: new FormControl(''),
            filter_cnp: new FormControl(''),
            filter_absente: new FormControl(-1),
        });
    }

    dtLink =
        environment.interop.basePath +
        environment.interop.dgaspc.activitati.copii.getCopiiDT;

    constructor(
        private http: HttpClient,
        private beneficiariService: BeneficiariService,
        public permissionsService: PermissionsService,
        private dialog: MatDialog,
        private dialogService: DialogService,
        private route: ActivatedRoute,
        private location: Location,
    ) { }

    ngOnInit(): void {
        const routedEntity = this.route.snapshot.queryParamMap.get('id');
        const entityId = routedEntity ? Number(routedEntity) : null;

        if (entityId) {
            this.openInfoDialog(entityId);

            // Remove the id from URL without refreshing
            this.location.replaceState('/beneficiari');
        }

        this.renderDT();
        this.buildSearchParamsForm();
    }

    ngAfterViewInit(): void {
        this.dtTrigger.next('');
    }

    ngOnDestroy(): void {
        this.dtTrigger.unsubscribe();
    }

    formatDate(dateString: string): string {
        if (!dateString) return '';

        const date = new Date(dateString);

        // Check if date is valid
        if (isNaN(date.getTime())) return '';

        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();

        return `${day}.${month}.${year}`;
    }

    renderDT() {
        this.isLoading = true;
        this.dtOptions = {
            serverSide: true,
            searching: false,
            responsive: true,

            ajax: (dataTablesParameters: any, callback: any) => {
                this.isLoading = true;
                Object.assign(dataTablesParameters, { ...this.searchParamsForm.value });

                this.http
                    .post<DataTablesResponse>(this.dtLink, dataTablesParameters)
                    .subscribe((resp: any) => {
                        this.isLoading = false;
                        callback({
                            recordsTotal: resp.data.recordsTotal,
                            recordsFiltered: resp.data.recordsFiltered,
                            data: resp.data.data,
                        });
                    });
            },
            language: environment.config.romanianLanguageDataTable,
            columns: [
                {
                    title: 'ID',
                    data: 'id',
                },
                {
                    title: 'Nume și prenume',
                    data: 'full_name',
                    orderable: false,
                },
                {
                    title: 'Data nașterii',
                    data: 'birth_date',
                    orderable: false,
                    render: (data: string) => {
                        return this.formatDate(data);
                    },
                },
                {
                    title: 'CNP',
                    data: 'cnp',
                    orderable: false,
                },
                // {
                //     title: 'Locație',
                //     data: 'personal_data',
                //     orderable: false,
                //     render: (data: any) => {
                //         return data.locatie;
                //     },
                // },
                // {
                //     title: 'Părinți',
                //     data: 'personal_data',
                //     orderable: false,
                //     render: (data: any) => {
                //         return data.parintii;
                //     },
                // },
                {
                    title: 'Date de contact',
                    data: 'contact_info',
                    orderable: false,
                    render: (data: any, type: any, row: any) => {
                        if (!row.email && !row.phone) return 'N/A';
                        const email = row.email || 'N/A';
                        const phone = row.phone || 'N/A';
                        return `${email}, ${phone}`;
                    },
                },
                {
                    title: 'Data actualizării / Ultima actualizare',
                    data: 'updated_at',
                    render: (data: string) => {
                        return this.formatDate(data);
                    },
                },
            ],
            rowCallback: (row: Node, data: any[] | any) => {
                $('td', row).off('click');

                $('td:not(:first-child)', row).on('click', () => {
                    this.onRowClick(data.id);
                });

                return row;
            },
        };
    }

    onRowClick(entityId: number) {
        this.openInfoDialog(entityId);
    }

    rerenderDT(paginate = false): void {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.draw(paginate);
        });

        this.showCard = false;
    }

    openAddDialog() {
        const dialogRef = this.dialog.open(AddBeneficiarComponent, {
            ...this.dialogService.getDialogConfig(),
        });
        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.isLoading = true;
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: 'Beneficiar adăugat cu succes.',
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            }
        });
    }

    openInfoDialog(id: number) {
        const dialogRef = this.dialog.open(BeneficiariDetaliiComponent, {
            minHeight: '100vh',
            maxHeight: '100vh',
            minWidth: '100vw',
            maxWidth: '100vw',
            disableClose: true,
            data: {
                beneficiar: { id, },
            },
        });

        dialogRef.afterClosed().subscribe(() => {
            this.rerenderDT();
        });
    }
}
